/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpSharedBlurbPcs_user$ref = any;
type PdpSharedBlurbReturns_user$ref = any;
type PdpSharedBlurbShipping_user$ref = any;
type PdpSharedBlurbSupportNumber_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespSidebarBlurbs_user$ref: FragmentReference;
export type PdpRespSidebarBlurbs_user = {|
  +$fragmentRefs: PdpSharedBlurbPcs_user$ref & PdpSharedBlurbShipping_user$ref & PdpSharedBlurbReturns_user$ref & PdpSharedBlurbSupportNumber_user$ref,
  +$refType: PdpRespSidebarBlurbs_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespSidebarBlurbs_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbPcs_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbShipping_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbReturns_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbSupportNumber_user",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'b74628f8f8593d8fb838fad3af4386d8';
module.exports = node;
